// NOTE: NSAI-6470 — one height for every control on the auth screens. Sign in
// used to stack a 56px SSO button, a 40px email field, a 48px password field
// and a 48px submit button in one column, so the first screen of the product
// read as four mismatched boxes. Both constants live here so a change to the
// auth forms cannot drift them apart again.
export const AUTH_CONTROL_HEIGHT_CLASS = "h-12" as const;
